export enum precisionValue {
    Actual = 'Actual',
    Summarized = 'Summarized',
    Decimal = 'Decimal',
}